import type { PayloadActionWithoutType } from '../../types/types'

import { updateWeeklyscheduleById } from './updateWeeklyscheduleById'

type Params = PayloadActionWithoutType<{
  weeklyscheduleId: number
}>

export function* unpublishWeeklyscheduleById({
  payload: { weeklyscheduleId }
}: Params): any {
  yield updateWeeklyscheduleById({
    payload: {
      weeklyscheduleId,
      data: {
        published: false
      }
    }
  })
}
